module.exports = __webpack_public_path__ + "img/container_img07.0df37738.png";